// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '../environmentConfig';

export const config: EnvironmentConfig = {
  production: false,
  partnersApi: 'https://deal-hunter-partner-api.sg-preprod.cosmose.cloud/deal-hunter-partner-api/v1',
  apiRoot: 'https://api.jp.cosmose.co/uaa',
  pushNotificationApi: 'https://pns.sg-preprod.cosmose.cloud/push-notification-service/v1',
  apiKey: 'ZGVhbC1odW50ZXItcGFydG5lci13ZWI6S0pkc3ExMmRhc2JCS0g=',
  prefix: 'Bearer',
  smartLookIntegration: false,
  smartLookKey: undefined,
  sentryIntegration: false,
  gtmId: 'GTM-NTSKSDC',
  kaikaiUrl: {
    'Singapore': 'https://kaikai.preprod.cosmose.cloud',
    'Hong Kong': 'https://hk.kaikai.preprod.cosmose.cloud',
    'USA': 'https://us.kaikai.preprod.cosmose.cloud',
    DEFAULT: 'https://kaikai.preprod.cosmose.cloud',
  },
};
